"use client";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { FontSize100, ColorGreen500, SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
const defaultPromoTextColor = ColorGreen500;
const StyledPromoText = styled(Typography, {
  shouldForwardProp: (props) => props !== "productTileMaxLineNumber"
})(({
  productTileMaxLineNumber = 3
}) => {
  return {
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: productTileMaxLineNumber,
    color: ColorGreen500,
    display: "-webkit-box",
    fontSize: FontSize100,
    lineClamp: productTileMaxLineNumber,
    overflow: "hidden"
  };
});
const promoTextStyles = {
  WebkitBoxOrient: "vertical",
  display: "-webkit-box",
  overflow: "hidden"
};
const priceGroupContainerStyles = {
  display: "flex",
  flexDirection: "column",
  gap: SpaceXxs
};
export {
  StyledPromoText,
  defaultPromoTextColor,
  priceGroupContainerStyles,
  promoTextStyles
};
